/* eslint-disable */
import { ActionTypes } from "../actions/blogCategoryActions";

const initailData = {
    blogCategoryList: []
};

export const blogCategoryReducers = (state = initailData, action) => {
    switch (action.type) {
        case ActionTypes.GET_BLOG_CATEGORY_LIST:
            return {
                ...state,
                blogCategoryList: action.payload,
            };
        case ActionTypes.ADD_BLOG_CATEGORY_LIST:
            const oldBlogCategory = [...state.blogCategoryList];
            oldBlogCategory.unshift(action.payload);
            return {
                ...state,
                blogCategoryList: oldBlogCategory,
            };
        case ActionTypes.EDIT_BLOG_CATEGORY_LIST:
            const categoryBlogListOld = [...state.blogCategoryList]; 
            const updateBlogCategoryList = categoryBlogListOld.map((elm) => {
                if(elm?.id === action?.payload?.id) {
                    return{
                        ...elm,
                        name : action.payload.name,
                        slug : action.payload.slug,
                        is_active : action.payload.is_active,
                        updated_at : action.payload.updated_at,
                    }
                }else 
                return elm;
            });
            return {
                ...state,
                blogCategoryList: updateBlogCategoryList,
            };
        case ActionTypes.DELETE_BLOG_CATEGORY_LIST:
            const blogCategoryLists = [...state.blogCategoryList]; 
            const NewUpdatedBlogCategoryList = [];
            blogCategoryLists && blogCategoryLists.filter((elm) => {
                if(elm?.id !== action.payload.id) {
                    return NewUpdatedBlogCategoryList.push(elm);
                }
            });

            return {
                ...state,
                blogCategoryList: NewUpdatedBlogCategoryList,
            };
        default:
        return state;
    }
}